<script setup lang="ts">
import type { PackageName } from '@/types/lib/fontAwesome/PackageName'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps<{
  icon: [PackageName, string]
  title?: string
  customClass?: string
  disabled?: boolean
}>()
</script>

<template>
  <div :class="['button-flame', disabled ? 'disabled' : '', customClass]">
    <span class="title">{{ title }}</span>
    <font-awesome-icon :icon="props.icon" />
  </div>
</template>

<style lang="scss" scoped>
.button-flame {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 3rem;
}

.button-flame.disabled {
  background-color: #cccccc;
  cursor: auto;
}

.button-flame:not(.disabled):hover svg {
  color: #7a7a7a;
}

.button-flame .title {
  width: 100%;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
